import type { RouteRecordRaw } from 'vue-router'
import {
  bigSaleModules,
  getModuleMenuTitleKey,
  getModuleTitleKey,
  type BigSaleModuleMenu,
} from '@/data/modules'

const posModule = bigSaleModules.find((module) => module.id === 'pos')

if (!posModule) {
  throw new Error('POS module configuration was not found.')
}

function findPosMenu(path: string) {
  if (!posModule) {
    throw new Error('POS module configuration was not found.')
  }
  const menu = posModule.menus.find((item) => item.path === path)

  if (!menu) {
    throw new Error(`POS menu configuration was not found for [${path}].`)
  }

  return menu
}

function createPosMenuMeta(menu: BigSaleModuleMenu) {
  if (!posModule) {
    throw new Error('POS module configuration was not found.')
  }
  return {
    requiresAuth: true,
    moduleId: posModule.id,
    moduleCode: posModule.code,
    moduleTitle: posModule.title,
    moduleTitleKey: getModuleTitleKey(posModule),
    moduleIcon: posModule.icon,
    modulePath: posModule.path,
    menuTitle: menu.title,
    menuTitleKey: getModuleMenuTitleKey(posModule, menu),
    menuIcon: menu.icon,
    menuPath: menu.path,
    permissions: menu.permissions,
  }
}

const tableSalesMenu = findPosMenu('/pos')
const regularSalesMenu = findPosMenu('/sales')
const salesOrdersMenu = findPosMenu('/sales-orders')
const kitchenMenu = findPosMenu('/pos/kitchen')

export const posRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/views/layouts/PosLayout.vue'),
    meta: {
      requiresAuth: true,
      moduleId: posModule.id,
      moduleCode: posModule.code,
      moduleTitle: posModule.title,
      moduleTitleKey: getModuleTitleKey(posModule),
      moduleIcon: posModule.icon,
      modulePath: posModule.path,
    },
    children: [
      {
        path: 'pos',
        name: 'pos-table-sales',
        component: () => import('@/views/pages/pos/PosComponent.vue'),
        meta: createPosMenuMeta(tableSalesMenu),
      },
      {
        path: 'sales',
        name: 'module-pos-index',
        component: () => import('@/views/pages/modules/sale/SalePage.vue'),
        meta: createPosMenuMeta(regularSalesMenu),
      },
      {
        path: 'sales-orders',
        name: 'module-pos-sales-orders',
        component: () => import('@/views/pages/modules/sale/SalesOrderListPage.vue'),
        meta: createPosMenuMeta(salesOrdersMenu),
      },
      {
        path: 'sales-orders/form',
        name: 'module-pos-sales-order-form',
        component: () => import('@/views/pages/modules/sale/SalesOrderPage.vue'),
        meta: {
          ...createPosMenuMeta(salesOrdersMenu),
          permissions: ['sales_order.create'],
          pageTitleKey: 'sales.order.title',
        },
      },
      {
        path: 'pos/kitchen',
        name: 'pos-kitchen',
        component: () => import('@/views/pages/pos/BepBar.vue'),
        meta: { ...createPosMenuMeta(kitchenMenu), requiresKitchen: true },
      },
    ],
  },
]
